import { useDispatch } from "react-redux";
import { openPopup } from "../../../store/popupSlice"
import { Link } from "react-router-dom";

export default function LandingItalyLaunch({data}) {
  const dispatch = useDispatch();
  return (
    <>
      <section className="land2-launch">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="land2-launch-content">
                <div>
                  <h3 className="heading">{data.title}</h3>
                  <p>{data.desc}</p>
                </div>
                <span>
                  <button onClick={() => dispatch(openPopup())} className="default-white">{data.cta1}</button>
                 <Link to={"/features/taxi-software"}><button className="default-white">{data.cta2}</button></Link> 
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
